module.exports = __webpack_public_path__ + "media/images/icons/icon_tel_icon-82885b8657dc20efd61bc09376d73cb5.svg";